import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchAdministrationMotifsResolution } from 'store/administration/administrationActions';
import { patchMotifResolution } from 'store/administration/administrationActions';
import AdministrationMotifResolution from './AdministrationMotifResolution';
import withLoader from 'components/Shared/withLoader';

const AdministrationMotifResolutionWithLoader = withLoader(AdministrationMotifResolution);

class AdministrationMotifResolutionContainer extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            motifResolution: null
        };
    }

    async componentDidMount() {
        await this.props.fetchAdministrationMotifsResolution({ avecNbActions: false });

        let { id, motifsResolution } = this.props;

        if (id && id !== 0) {
            let motifResolution = motifsResolution.find(x => x.id === id);
            

            this.setState({
                motifResolution: JSON.parse(JSON.stringify(motifResolution))
            });
        }
    }
           


    handleChange = (event) => {
        let newMotifResolution = this.state.motifResolution;

        if (event.target.name === 'libelle') {
            newMotifResolution.libelle = event.target.value;
        }
        
        this.setState({ ...this.state, motifResolution: newMotifResolution });
    };





    handleClickCancel = (event) => {
        this.setState({
            motifResolution: null
        });
    };

    handleClickSave = async (event, id) => {
        await this.props.patchMotifResolution(this.state.motifResolution);
        this.setState({
            motifResolution: null
        });
    };



    render() {
        const { isLoading, isPatching, motifsResolution} = this.props;
        const { motifResolution } = this.state;

        let sauvegardable = !motifResolution || (motifResolution.libelle.length > 0);


        return (
            <AdministrationMotifResolutionWithLoader
                isLoading={isLoading}
                isPatching={isPatching}
                motifsResolution={motifsResolution}
                
                selectedMotifResolution={motifResolution}

                onChange={this.handleChange}
                onClickCancel={this.handleClickCancel}
                onClickSave={this.handleClickSave}         

                onClickAddCode={this.handleClickAddCode}
                onClickRemoveCode={this.handleClickRemoveCode}
                

                sauvegardable={sauvegardable}
            />);
    }
}

AdministrationMotifResolutionContainer.propTypes = {
    id: PropTypes.number
};

const mapStateToProps = state => ({
    isLoading: state.administration.motifsResolution.isLoading,
    isPatching: state.administration.motifsResolution.isPatching,
    motifsResolution: state.administration.motifsResolution.items
});

const mapDispatchToProps = dispatch => ({
    fetchAdministrationMotifsResolution: (param) => dispatch(fetchAdministrationMotifsResolution(param)),
    patchMotifResolution: (motifResolution) => dispatch(patchMotifResolution(motifResolution))    
});

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationMotifResolutionContainer);